export default "assets/images/7df82bae917b68159f84998182f2fdc6.png";